import Card from '@components/Common/Card';
import CardBody from '@components/Common/Card/CardBody';
import CardImage from '@components/Common/Card/CardImage';

import styles from './style.module.css';
import Button from '@components/Forms/Button';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faShoppingBag} from '@fortawesome/free-solid-svg-icons';

import {PRODUCT_GROUPS_BASE_URL} from '@constants/common';
import {toThousand} from '@lib/utils';
import {useTranslation} from 'next-i18next';
import {ProductDisplaysEnum} from '@enums/product-display';
import {LocaleEnum} from '@enums/locale';
import {ImageInterface} from '@interfaces/images';

export default function ProductGroupCard({
  lowest_price,
  name,
  description,
  type,
  image,
  locale,
  seo_friendly_url,
}: {
  lowest_price?: number;
  name: string;
  description: string;
  type: ProductDisplaysEnum | null;
  image: ImageInterface;
  locale: LocaleEnum;
  seo_friendly_url: string;
}) {
  const productGroupSlug = seo_friendly_url;
  const {t} = useTranslation(['product-display']);
  let ViewUrl: string;
  if (type) {
    ViewUrl =
      t<string>(`product_display_urls.${type.toLowerCase()}`) +
      `${productGroupSlug}`;
  } else {
    ViewUrl = `${PRODUCT_GROUPS_BASE_URL[locale].link}${productGroupSlug}`;
  }
  return (
    <Card
      isLink={true}
      href={`${ViewUrl}`}
      locale={locale}
      classNames={styles.productGroupCard}
    >
      <CardImage image={image['image_fi']} alt={''} />
      <CardBody classNames={styles.productGroupBody}>
        <div className={styles.productInformation}>
          <h4 title={type || ''}>{name}</h4>
          <div
            dangerouslySetInnerHTML={{
              __html: description,
            }}
          ></div>
          <div className={styles.productFooter}>
            <Button href={`${ViewUrl}`} locale={locale} variant="link">
              <FontAwesomeIcon icon={faShoppingBag} />
              {t<string>('shop_now')}
            </Button>
            {lowest_price && type ? (
              <div className={styles.priceInformation}>
                <p>{t<string>('starting_price')}</p>
                <h5>
                  {toThousand(lowest_price)} €
                  <span className={styles.vatText}>
                    {t<string>('vat_exclusive')}
                  </span>
                </h5>
              </div>
            ) : null}
          </div>
        </div>
      </CardBody>
    </Card>
  );
}
